import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import styles from "./style.module.scss";
import { Icons } from "assets";
import ImageUploadButton from "shared/components/imageUploadButton";
import CustomButton from "shared/components/customButton";
import { updateAuthorProfileService, getAuthorProfileService } from "shared/services/productManagerService";
import { toastMessage } from "shared/components/toast";
import Loader from "shared/components/loader/animation";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface EditAuthorProfileProps {
  open: boolean;
  handleClose: any;
  authorId: number | null;
  getAllAuthors: any;
  initialProfilePic?: string;
}

export default function EditAuthorProfile({
  open,
  handleClose,
  authorId,
  getAllAuthors,
  initialProfilePic,
}: EditAuthorProfileProps) {
  const [image, setImage] = useState<{ preview: string; raw: File | null }>({
    preview: "",
    raw: null,
  });
  const [loader, setLoader] = useState<boolean>(false);
  const [profileLoader, setProfileLoader] = useState<boolean>(false);
console.log(initialProfilePic, "initialProfilePic");
  useEffect(() => {
    if (open && authorId) {
      if (initialProfilePic) {
        setImage({
          preview: initialProfilePic,
          raw: null,
        });
      }
    } else if (!open) {
      setImage({
        preview: "",
        raw: null,
      });
    }
  }, [open, initialProfilePic]);


  const handleEditProfile = () => {
    if (!authorId) return;

    if (!image?.raw) {
      toastMessage("error", "Please select an image to update");
      return;
    }

    let formBody = new FormData();
    formBody.append("profile_pic", image.raw);

    setLoader(true);
    updateAuthorProfileService(authorId, formBody)
      .then(({ data }) => {
        setLoader(false);
        toastMessage("success", data?.message || "Author profile updated successfully");
        handleClose();
        getAllAuthors();
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.message);
        setLoader(false);
      });
  };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xs"
        PaperProps={{
          className: styles.dialogPaper
        }}
      >
        <DialogContent className={styles.dialogContent}>
          <Icons.CrossIcon
            className={styles.crossIcon}
            onClick={() => handleClose()}
          />
          <div className={styles.modalContainer}>
            <div className={styles.heading}>Edit Author Profile Picture</div>
            {profileLoader ? (
              <div className={styles.loaderContainer}>
                <Loader />
              </div>
            ) : (
              <div className={styles.contentWrapper}>
                <ImageUploadButton image={image || { preview: initialProfilePic, raw: null }} setImage={setImage} />
                <div className={styles.buttonContainer}>
                  <CustomButton
                    text="Cancel"
                    buttonStyle={styles.btnCancel}
                    handleClick={handleClose}
                  />
                  <CustomButton
                    text="Save"
                    buttonStyle={styles.btnCustom}
                    handleClick={handleEditProfile}
                  />
                </div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
      {loader && <Loader />}
    </div>
  );
}
